<template>
    <div>
        <div class="form-horizontal">

            <form-input :form="form" property="active">
                <input type="checkbox" v-model="form.active">
            </form-input>


            <form-input :form="form" property="category_id" label="Category">
                <select3 :value="form.category" @input="setCategory" allow-clear data-url="/api/blogs/categories?root=true" value-key="name"></select3>
            </form-input>


            <form-input :form="form" property="title"></form-input>
            <form-input :form="form" property="slug"></form-input>

            <form-input :form="form" property="meta_description">
                <textarea v-model="form.meta_description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>
            <form-input :form="form" property="description">
                <textarea v-model="form.description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input :form="form" property="background_color">
                <input v-model="form.background_color" class="form-control" cols="10" rows="1"/>
            </form-input>

            <form-input :form="form" property="image" label="Photo">
                <photo-upload @input="files.image = $event" :value="form.image.url" @clear="files.image = null; form.image = {url: ''}"></photo-upload>
            </form-input>

            <form-input-trans :form="form" property="image.alt"></form-input-trans>

            <form-input :form="form" property="body">
                <text-editor v-model="form.body"></text-editor>
            </form-input>

            <form-input :form="form" property="published_at">
                <datepicker v-model="form.published_at" input-class="form-control" />
            </form-input>

            <form-input :form="form" property="created_at">
                <datepicker v-model="form.created_at" input-class="form-control" />
            </form-input>

            <form-input :form="form" property="read_time"  label="Read time in minutes"></form-input>

            <form-faq :form="form"/>

            <!-- <div v-for="(faq,index) in form.faqs" :key="index" class="mb-5">
                <form-input :form="form" :property="`faqs[${index}]['question']`" :label="`Question ${index + 1}`">
                    <input v-model="form.faqs[index].question" class="form-control"/>
                </form-input>
                <form-input :form="form" :property="`faqs[${index}]['answer']`" :label="`Answer ${index + 1}`">
                    <textarea v-model="form.faqs[index].answer" class="form-control" cols="10" rows="5"></textarea>
                </form-input>
            </div>
            <div class="text-right">
                <button class="btn btn-success mt-3 mb-5" @click.prevent.stop="addFaq">Add Question</button>
            </div> -->
            <!-- <form-input :form="form" property="tags" label="Tags" v-if="tagsAll">
                <div class="m-checkbox-inline">
                    <label class="m-checkbox" v-for="tag in tagsAll"> {{ tag.name }}
                        <input type="checkbox" :checked="isSelected(tag)" @change="toggleTag(tag, $event)">
                        <span></span>
                    </label>
                </div>
            </form-input> -->

            <hr>
            <h2>Author Details</h2>
            <form-input :form="form" property="author_id" label="Author">
                <select3 :value="form.author" @input="setAuthor" allow-clear data-url="/api/blogs/authors" value-key="full_name"></select3>
            </form-input>

            <activity-log v-if="exists" :api="`/api/blogs/posts/${form.id}/activity`" ref="activityLog"></activity-log>


        </div>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';
import UploadFiles from 'lib/UploadFiles';
import axios from 'axios';

export default {
    mixins: [Model, UploadFiles],
    data() {
        return {
            method: '/api/blogs/posts',
            form: new Form(() => {
                return {
                    active:false,
                    name: null,
                    title: null,
                    slug: null,
                    meta_keyword: null,
                    meta_keywords: null,
                    meta_description: null,
                    description: null,
                    background_color: '#fff',
                    body: null,
                    image: {
                        alt: {}
                    },
                    category: null,
                    category_id: null,
                    read_time: null,
                    published_at: null,
                    created_at: null,
                    tags: [],
                    author_id:null,
                    author:null,
                    faqs: [],
                };
            }),
            tagsAll: null,
            slug: '',
            validSlug: '',
        };
    },
    methods: {
        setCategory: function(category) {
            this.form.subcategory = null;
            this.form.subcategory_id = null;

            if (category) {
                this.form.category = category;
                this.form.category_id = category.id;

            } else {
                this.form.category = null;
                this.form.category_id = null;
            }
        },
        setAuthor(author){
            if (author) {
                this.form.author = author;
                this.form.author_id = author.id;

            } else {
                this.form.author = null;
                this.form.author_id = null;
            }
        },
        isSelected(tag) {
            if (!this.form) {
                return false;
            }
            return this.form.tags.find(x => x.id == tag.id);
        },
        toggleTag(tag) {
            if (this.isSelected(tag)) {
                this.form.tags = this.form.tags.filter(x => x.id != tag.id);
            } else {
                this.form.tags.push(tag);
            }
        },
        addFaq() {
            this.form.faqs.push({
                question: '',
                answer: '',
            });
        },
    },
    mounted() {
        this.$on('input', () => {
            if (this.$refs.activityLog) {
                this.$refs.activityLog.load();
            }
        });
        axios.get('/api/blogs/tags', {
            //                params: {'q_type': this.form.type },
        }).then(res => {
            this.tagsAll = res.data.data;
        });
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/blogs/Post.vue